import { useState } from 'react';
import { useLang } from '@/i18n/LanguageContext';

const URLS = {
  account: 'mindstream.app/accounts/granola',
  manager: 'mindstream.app/team',
};

export default function Atlas() {
  const { t } = useLang();
  const [pane, setPane] = useState<'account' | 'manager'>('account');

  return (
    <section className="section" id="atlas" data-screen-label="Atlas">
      <div className="container">
        <div className="section-head reveal">
          <span className="eyebrow">{t('atlas.eyebrow')}</span>
          <h2 className="h-section">
            {t('atlas.h2.line1')}
            <br />
            {t('atlas.h2.line2')}
          </h2>
          <p className="lead">{t('atlas.lead')}</p>
        </div>

        <div className="reveal" data-d="1" style={{ marginTop: 48 }}>
          <div className="atlas-win mock" id="atlasWin">
            <div className="app-bar">
              <div className="traffic">
                <i />
                <i />
                <i />
              </div>
              <div className="app-tabs">
                <button
                  className={`app-tab${pane === 'account' ? ' active' : ''}`}
                  onClick={() => setPane('account')}
                >
                  {t('atlas.tab.account')}
                </button>
                <button
                  className={`app-tab${pane === 'manager' ? ' active' : ''}`}
                  onClick={() => setPane('manager')}
                >
                  {t('atlas.tab.manager')}
                </button>
              </div>
              <span className="app-url">{URLS[pane]}</span>
            </div>

            {/* Account view pane */}
            <div className={`app-pane${pane === 'account' ? ' active' : ''}`}>
              <div className="av">
                <div className="av-main">
                  <div className="av-head">
                    <div className="av-logo">G</div>
                    <div style={{ minWidth: 0 }}>
                      <div className="av-name">Granola</div>
                      <div className="av-meta">Mid-market · Series B · HubSpot · Owner: You</div>
                    </div>
                    <div className="av-badges">
                      <span className="av-badge warm">Warming</span>
                      <span className="av-badge val">$14.4K</span>
                    </div>
                  </div>
                  <div className="av-summary">
                    Granola is <u>evaluating Mindstream for a 12-seat sales team</u>. Budget was confirmed
                    in the latest thread; Chris owns the eval and Dana gates procurement. Momentum is
                    accelerating — three meaningful touches in the last week. Next step is the product
                    demo deck, <u>due Tuesday</u>.
                  </div>
                  <div className="av-events">
                    <span className="av-lbl">Meaningful events</span>
                    <div className="av-tl">
                      <div className="av-ev green">
                        <div className="ev-t">Budget approved for ~12 seats</div>
                        <div className="ev-m">Email · Chris Pedregal · 2 days ago</div>
                      </div>
                      <div className="av-ev violet">
                        <div className="ev-t">Demo meeting scheduled</div>
                        <div className="ev-m">Calendar · Tue 2:00 PM · 4 days ago</div>
                      </div>
                      <div className="av-ev amber">
                        <div className="ev-t">Procurement looped in</div>
                        <div className="ev-m">Email · Dana Reyes · 5 days ago</div>
                      </div>
                      <div className="av-ev faint">
                        <div className="ev-t">First inbound — overview requested</div>
                        <div className="ev-m">Email · Chris Pedregal · 3 weeks ago</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="av-side">
                  <div className="grp">
                    <span className="av-lbl">Sentiment trajectory</span>
                    <div className="sent-bar" />
                    <div className="sent-row">
                      <span className="sl">Warming · 72%</span>
                      <span className="sr">↑ trending up</span>
                    </div>
                  </div>
                  <div className="grp">
                    <span className="av-lbl">Stakeholder map</span>
                    <div className="sh-row">
                      <div className="av2" style={{ background: '#16a571' }}>
                        CP
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <div className="sh-n">Chris Pedregal</div>
                        <div className="sh-r">Head of Sales</div>
                      </div>
                      <span className="sh-b champ">Champion</span>
                    </div>
                    <div className="sh-row">
                      <div className="av2" style={{ background: '#7c5cf0' }}>
                        DR
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <div className="sh-n">Dana Reyes</div>
                        <div className="sh-r">Procurement</div>
                      </div>
                      <span className="sh-b gate">Gatekeeper</span>
                    </div>
                    <div className="sh-row">
                      <div className="av2" style={{ background: '#3d8bf0' }}>
                        MK
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <div className="sh-n">Maya Kuo</div>
                        <div className="sh-r">Legal</div>
                      </div>
                      <span className="sh-b neutral">Neutral</span>
                    </div>
                  </div>
                  <div className="grp">
                    <span className="av-lbl">Risk inference</span>
                    <div className="risk-box">
                      <b>Watch:</b> Procurement can add 2–3 weeks. Pre-empt with security docs now.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Manager dashboard pane */}
            <div className={`app-pane${pane === 'manager' ? ' active' : ''}`}>
              <div className="md">
                <div className="md-tiles">
                  <div className="md-tile">
                    <div className="big">$1.2M</div>
                    <div className="cap">Pipeline observed · 38 accounts</div>
                  </div>
                  <div className="md-tile risk">
                    <div className="big">5</div>
                    <div className="cap">Ghost-risk accounts surfacing</div>
                  </div>
                  <div className="md-tile move">
                    <div className="big">11</div>
                    <div className="cap">Deals moving this week</div>
                  </div>
                </div>
                <span className="md-lbl">Accounts needing attention</span>
                <div className="md-row">
                  <div className="ravatar2" style={{ background: '#3d8bf0' }}>
                    A
                  </div>
                  <div>
                    <div className="mr-n">Acme Corp</div>
                    <div className="mr-o">Owner · Jordan M.</div>
                  </div>
                  <div className="mr-note">No reply 11 days · budget delay</div>
                  <span className="mr-stat ghost">Ghost risk</span>
                </div>
                <div className="md-row">
                  <div className="ravatar2" style={{ background: '#7c5cf0' }}>
                    V
                  </div>
                  <div>
                    <div className="mr-n">Vercel</div>
                    <div className="mr-o">Owner · Priya S.</div>
                  </div>
                  <div className="mr-note">Budget cycle reopened — act now</div>
                  <span className="mr-stat reeng">Re-engage</span>
                </div>
                <div className="md-row">
                  <div className="ravatar2" style={{ background: '#c45cf0' }}>
                    M
                  </div>
                  <div>
                    <div className="mr-n">Moderna IT</div>
                    <div className="mr-o">Owner · Jordan M.</div>
                  </div>
                  <div className="mr-note">Champion left — relationship reset</div>
                  <span className="mr-stat handoff">Handoff</span>
                </div>
                <div className="md-row">
                  <div
                    className="ravatar2"
                    style={{ background: 'linear-gradient(135deg,#ffd9a8,#ff9f43)', color: '#7a3e00' }}
                  >
                    G
                  </div>
                  <div>
                    <div className="mr-n">Granola</div>
                    <div className="mr-o">Owner · You</div>
                  </div>
                  <div className="mr-note">Demo due Tue · on track</div>
                  <span className="mr-stat healthy">Healthy</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="reveal"
          data-d="2"
          style={{ marginTop: 34, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}
        >
          <p className="lead" style={{ fontSize: 16 }}>
            {t('atlas.foot.account')}
          </p>
          <p className="lead" style={{ fontSize: 16 }}>
            {t('atlas.foot.manager')}
          </p>
        </div>
      </div>
    </section>
  );
}
